import RecipesList from './RecipesList'

export default RecipesList
